/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
} from "@angular/core";
import { REGEX } from "../../../config/app.config";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { iconsLibrary } from "../../../../theme/constants";
@Component({
  selector: "cowing-input",
  templateUrl: "./cowing-input.component.html",
  styleUrls: ["./cowing-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingInputComponent),
      multi: true,
    },
  ],
})
export class CowingInputComponent implements ControlValueAccessor {
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Input("value") value: string;
  @Input("type") type: string = "text";
  @Input("fixedIcon") fixedIcon: boolean = false;
  @Input("inputStyle") inputStyle: string = EInputStyleType.Primary;
  @Input("iconShow") iconShow: boolean = false;
  @Input("iconName") iconName: string = "";
  @Input("label") label: string = "";
  @Input("placeholder") placeholder: string = "";
  @Input("required") required: boolean = false;
  @Input("validateInput") validateInput: boolean = true;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;
  @Input("disabled") disabled: boolean = false;
  @Input("readonly") readonly: boolean = false;

  @ViewChild("input") input: ElementRef;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";

  private internalInputChange;
  constructor() {}

  public onInputChange($event?: any) {
    if ($event) {
      this.value = $event.target.value;
      this.internalInputChange(this.value);
      this.validateFormat();
    }
  }

  public get getIcon() {
    return `${iconsLibrary[this.iconName]}`;
  }

  // toggleShowPassword() {
  //   this.toggledShowPassword = !this.toggledShowPassword;
  //   this.type = this.toggledShowPassword ? "text" : "password";
  // }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalInputChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }

  onChangeKeyboard(input) {
    this.value = input;
    this.internalInputChange(this.value);
    this.validateFormat();
  }

  onKeyPress(button) {
    console.log("Button pressed", button);
  }

  validateFormat() {
    if (this.required) {
      console.log("required", this.value);
      this.msg =
        this.value != "" && this.value != null
          ? ""
          : "common.validation.required";
      this.status = this.value != "" && this.value != null ? "" : "error";
      this.valid = this.value != "" && this.value != null ? true : false;
      this.checked = this.value != "" && this.value != null ? false : true;
    } else {
      this.valid = true;
    }
    if (this.valid) {
      if (this.type === "email") {
        this.checked = true;
        const regexMail: RegExp = REGEX.MAIL;
        this.valid = regexMail.test(this.value);
        if (this.valid) {
          this.msg = "common.validation.email.ok";
          this.status = "valid";
        } else {
          this.msg = "common.validation.email.error";
          this.status = "error";
        }
      } else if (this.type === "phone") {
        this.checked = true;
        const regexPhone: RegExp = REGEX.PHONE;
        this.valid = regexPhone.test(this.value);
        if (this.valid) {
          this.msg = "common.validation.phone.ok";
          this.status = "valid";
        } else {
          this.msg = "common.validation.phone.error";
          this.status = "error";
        }
      }
      //   else if (this.isPassword && this.validateInput) {
      //     this.checked = true;
      //     const regexPassword: RegExp = REGEX.PASSWORD;
      //     this.valid = regexPassword.test(this.value);
      //     if (this.valid) {
      //       this.msg = "common.validation.password.ok";
      //       this.status = "valid";
      //     } else {
      //       this.msg = "common.validation.password.error";
      //       this.status = "error";
      //     }
      //   }
    }
  }
}
